<app-agricola-navbar></app-agricola-navbar>

<div class="reportes-container">
  <div class="reportes-content">
    <!-- Header Section -->
    <div class="header-section">
      <button class="back-button" type="button" (click)="goBack()">
        <img src="assets/agricola/back.svg" alt="Volver" />
        <span>Volver</span>
      </button>
      <h1 class="title">Gestion y Reportes</h1>
      <h2 class="subtitle">Generacion de reportes</h2>
    </div>

    <!-- Report Cards -->
    <div class="cards-container">
      <button class="card pcard" type="button" *ngFor="let card of cards" (click)="onCardClick(card)">
        <div class="card-icon-container" [style.background]="card.iconBg">
          <i [class]="card.icon" aria-hidden="true"></i>
          <div class="new-badge" *ngIf="card.isNew">
            <span>Nuevo</span>
          </div>
        </div>
        <div class="card-content">
          <h3 class="card-title">{{ card.title }}</h3>
          <p class="card-description">{{ card.description }}</p>
          <span class="card-link">Ver más</span>
        </div>
      </button>
    </div>
  </div>
</div>
